export default "__VITE_ASSET__BDiFBtz___"